import { render, staticRenderFns } from "./HeaderDashboard.vue?vue&type=template&id=50e4f8ca&scoped=true&"
import script from "./HeaderDashboard.vue?vue&type=script&lang=js&"
export * from "./HeaderDashboard.vue?vue&type=script&lang=js&"
import style0 from "./HeaderDashboard.vue?vue&type=style&index=0&id=50e4f8ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e4f8ca",
  null
  
)

export default component.exports